<div class="container">
  <div class="row mtb-50 align-items-center">
    <h2
      class="card-title engaged-section-title mt-0 text-center"
      *ngIf="titlePosition === 'center'">
      READY TO BUILD A MORE ENGAGED, VIBRANT SENIOR LIVING COMMUNITY?
    </h2>
    <div class="col-md-4 main-img">
      <img
        class="card-img-top img-fluid"
        src="assets/images/homepage/dashboard-mockup.png" />
    </div>
    <div class="col-md-8" *ngIf="!isSentInd">
      <div class="engaged-section-info" *ngIf="titlePosition === 'right'">
        <h2 class="card-title mt-0 text-center">
          Ready to build a more engaged, vibrant senior living community?
        </h2>
        <p>
          Complete the form <br />
          and someone will contact you with the information you're looking for:
        </p>
      </div>
      <form [formGroup]="contactForm" class="mt-20">
        <div class="row col-9 mx-auto justify-content-md-start">
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="name">First Name</label>
            <input
              type="text"
              class="form-control"
              id="first-name"
              formControlName="firstName"
              placeholder="First Name" />
          </div>
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="name">Last Name</label>
            <input
              type="text"
              class="form-control"
              id="last-name"
              formControlName="lastName"
              placeholder="Last Name" />
          </div>
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="email">Phone #</label>
            <input
              type="text"
              class="form-control"
              id="phone"
              formControlName="phone"
              placeholder="Phone #" />
          </div>
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="email">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
              placeholder="Email" />
          </div>
          <div class="col col-12 mb-3">
            <label class="visually-hidden" for="email">Job Title</label>
            <input
              type="text"
              class="form-control"
              id="job-title"
              formControlName="jobTitle"
              placeholder="Job Title" />
          </div>
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="email">Company Name</label>
            <input
              type="text"
              class="form-control"
              id="company-name"
              formControlName="companyName"
              placeholder="Company Name" />
          </div>
          <div class="col col-6 mb-3">
            <label class="visually-hidden" for="email">HQ State</label>
            <input
              type="text"
              class="form-control"
              id="hq-state"
              formControlName="hqState"
              placeholder="HQ State" />
          </div>
          <div class="col col-12 mb-3">
            <label class="visually-hidden" for="email">Message</label>
            <input
              type="text"
              class="form-control"
              id="message"
              formControlName="message"
              placeholder="Message" />
          </div>
          <div class="col col-lg-3">
            <button
              type="submit"
              class="btn btn-primary w-md"
              [disabled]="!contactForm.valid"
              (click)="onSubmit()">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="col-md-8" *ngIf="isSentInd">
      <h2 class="card-title mtb-50">An agent will contact you soon</h2>
    </div>
  </div>
</div>
